import React, { createContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getTotalPointsRequest } from "../redux/get_total_points/actions";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../Components/Common/Toast";
import { fetchRewardsPointsRequest } from "../redux/fetch_rewards_points/actions";
import { logoutRequest,resetLogout } from "../redux/auth/logout/actions";
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({ type: "", isLoggedin: false });
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem("_token");
    
    if (token) {
      console.log("auth context");
      const userData = JSON.parse(localStorage.getItem("user_data"));
      setUser({ type: userData.type, isLoggedin: true });
    }
  }, [localStorage.getItem("_token")]);

  // const logout = () => {
  //   const user_data = JSON.parse(localStorage.getItem("user_data"));
    
  //   // delete central cookie
  //   const central_url = 'https://zoblik.com/sso/';
  //   fetch(central_url + 'logout.php', {
  //       credentials: 'include',
  //       method: 'POST',
  //       headers: {
  //           'Content-Type': 'application/json'
  //       }
  //   });
  //   // dispatch action to delete local token from db
  //   dispatch(logoutRequest());
  //   localStorage.removeItem("user_data");
  //   localStorage.removeItem("_token");
  //   setUser({ type: "", isLoggedin: false });
    
  //   // <Navigate
  //   //   to={`${process.env.PUBLIC_URL}/${user_data.type.toLowerCase()}/login`}
  //   //   replace
  //   // />;
  // };


  const logout = async () => {
    const user_data = JSON.parse(localStorage.getItem("user_data"));
    const central_url = 'https://zoblik.com/sso/';

    try {
      console.log("aaa",user.type.toUpperCase());
      if (user.type.toUpperCase() === 'JOBSEEKER') {
        const response = await fetch(central_url + 'logout.php', {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        console.log("responseff",response);
        if (!response.ok) {
          throw new Error(`Logout failed with status: ${response.status}`);
        }
      }
        // Dispatch action to delete local token from the Redux store
        dispatch(logoutRequest());

        // // Clear user data from local storage
        // localStorage.removeItem("user_data");
        // localStorage.removeItem("_token");

        // // Update user state to reflect that the user is logged out
        // setUser ({ type: "", isLoggedin: false });

        // Optionally navigate to the login page
        // <Navigate to={`${process.env.PUBLIC_URL}/${user_data.type.toLowerCase()}/login`} replace />;
        
    } catch (error) {
        console.error('Error during logout:', error);
    }
  };
  

  const logoutReducerData = useSelector((state) => state.logoutReducer);
    
  
    useEffect(() => {
  
      if (logoutReducerData.status && logoutReducerData.message) {
        console.log("loginData", logoutReducerData.message);
        showToast("success", logoutReducerData.message);
        dispatch(resetLogout());
       

       
        setTimeout(() => {
          // Clear user data from local storage
           localStorage.removeItem("user_data");
          localStorage.removeItem("_token");
          localStorage.removeItem("jobseeker_resume_redirected");
          localStorage.removeItem("jobseeker_education_redirected");
          
          // Update user state to reflect that the user is logged out
           setUser({ type: "", isLoggedin: false });
          // <Navigate to={`${process.env.PUBLIC_URL}/${user.type.toLowerCase()}/login`} replace />
        }, 1000); // Adjust the delay as needed (2000ms = 2 seconds)
  
      } else if (!logoutReducerData.status && logoutReducerData.message) {
        showToast("error", logoutReducerData.message);
        dispatch(resetLogout());
      }
    }, [logoutReducerData,dispatch, user.type]);
  
  
  const [totalPoints, setTotalPoints] = useState(0);

  useEffect(() => {
    dispatch(getTotalPointsRequest());
  }, []);

  const getTotalPointsReducerData = useSelector(
    (state) => state.getTotalPointsReducer
  );

  useEffect(() => {
    if (
      getTotalPointsReducerData &&
      !getTotalPointsReducerData.isLoading &&
      getTotalPointsReducerData.total_points
    ) {
      setTotalPoints(getTotalPointsReducerData.total_points);
    }
  }, [getTotalPointsReducerData]);

  const fetchRewardsPointsReducerData = useSelector(
    (state) => state.fetchRewardsPointsReducer
  );
  useEffect(() => {
    if (
      !fetchRewardsPointsReducerData ||
      !fetchRewardsPointsReducerData.data ||
      !Array.isArray(fetchRewardsPointsReducerData.data) ||
      fetchRewardsPointsReducerData.data.length <= 0
    ) {
      dispatch(fetchRewardsPointsRequest());
    }
  }, []);

  const triggerTotalPoints = (
    actionName,
    // increment = true,
    showToastMessage = true,
    numberOfUploads = 1, // Default to 1 if not provided
    isDeduct = true
  ) => {
    const actionItem = fetchRewardsPointsReducerData.data.find(
      (item) => item.name === actionName
    );
// added by shanu on 22 aug 2026
    console.log("actionItem", actionItem, actionName, numberOfUploads);

    if (actionItem) {
      let actionPoints = parseInt(actionItem.points, 10);
       let actionType = actionItem.type;

      // If the action type is bulkUpload, multiply the points by the number of uploads
      if (actionName === "bulk_upload") {
        actionPoints *= numberOfUploads;
      }

      const newTotalPoints = (actionType === "reward" )
        ? +totalPoints + +actionPoints
        : +totalPoints - +actionPoints;
      setTotalPoints(newTotalPoints);
      // setTotalPoints(getTotalPointsReducerData.total_points);
      console.log("newTotalPoints", totalPoints, actionPoints, newTotalPoints);
      if (showToastMessage) {
        showToast(
          "success",
          `${actionPoints} points ${(actionType === "reward" ) ? "added to" : "deducted from"
          } your account for ${actionName.replace(/_/g, " ")}!`
        );
      }
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        logout,
        totalPoints,
        triggerTotalPoints,
        setTotalPoints,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
